module.exports = __webpack_public_path__ + "static/media/IMG_6414.987697d6.JPG";